export const TITLE = "Telepagos - AdminApp";
export const loaderColor = "#0077ba";
// export const loaderColor = "#f29525";
